<template>
	<div class="pp-phone" aria-label="Anteprima della notifica sul telefono">
		<div class="pp-notch"></div>
		<div class="pp-screen">
			<div class="pp-clock">{{ ora }}</div>
			<div class="pp-date">{{ giorno }}</div>
			<div class="pp-card">
				<div class="pp-head">
					<span class="pp-app"><v-icon x-small color="white">mdi-bell</v-icon></span>
					<span class="pp-app-name">{{ negozio }}</span>
					<span class="pp-time">adesso</span>
				</div>
				<div class="pp-title" :class="{ 'pp-empty': !titolo }">{{ titolo || 'Titolo della notifica' }}</div>
				<div class="pp-body" :class="{ 'pp-empty': !messaggio }">{{ messaggio || 'Il testo del messaggio comparirà qui' }}</div>
				<div v-if="immagine && !immagineRotta" class="pp-image">
					<img :src="immagine" alt="" @error="immagineRotta = true" />
				</div>
				<div v-else-if="immagine" class="pp-image-ko"><v-icon x-small class="mr-1">mdi-image-broken-variant</v-icon>L'immagine non si carica: controlla l'URL</div>
			</div>
			<div v-if="link" class="pp-link"><v-icon x-small color="white" class="mr-1">mdi-link-variant</v-icon>apre {{ dominio }}</div>
		</div>
	</div>
</template>

<script>
// anteprima di una notifica push sulla schermata di blocco di un telefono
export default {
	name: 'PushPreview',
	props: {
		titolo: { type: String, default: '' },
		messaggio: { type: String, default: '' },
		immagine: { type: String, default: '' },
		link: { type: String, default: '' },
		negozio: { type: String, default: 'Il tuo shop' },
	},
	data() {
		return { immagineRotta: false };
	},
	computed: {
		ora() {
			return new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
		},
		giorno() {
			return new Date().toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
		},
		dominio() {
			try {
				return new URL(this.link).hostname;
			} catch (e) {
				return this.link;
			}
		},
	},
	watch: {
		immagine() {
			this.immagineRotta = false;
		},
	},
};
</script>

<style scoped>
.pp-phone {
	position: relative;
	width: 100%;
	max-width: 300px;
	margin: 0 auto;
	padding: 12px;
	border-radius: 36px;
	background: #1f2d3d;
	box-shadow: 0 10px 24px rgba(31, 45, 61, 0.18);
}
.pp-notch {
	position: absolute;
	top: 18px;
	left: 50%;
	width: 80px;
	height: 18px;
	margin-left: -40px;
	border-radius: 10px;
	background: #1f2d3d;
	z-index: 2;
}
.pp-screen {
	min-height: 420px;
	padding: 48px 12px 16px;
	border-radius: 26px;
	background: linear-gradient(160deg, #2b5876 0%, #4e4376 100%);
	color: #fff;
}
.pp-clock {
	text-align: center;
	font-size: 46px;
	font-weight: 300;
	line-height: 1;
}
.pp-date {
	text-align: center;
	font-size: 13px;
	opacity: 0.85;
	margin: 6px 0 22px;
	text-transform: capitalize;
}
.pp-card {
	padding: 10px 12px;
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.92);
	color: #1f2d3d;
	backdrop-filter: blur(6px);
}
.pp-head {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	margin-bottom: 4px;
}
.pp-app {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	border-radius: 5px;
	background: #01579b;
}
.pp-app-name {
	flex: 1 1 auto;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	color: #5f6b7a;
}
.pp-time {
	color: #8a96a3;
}
.pp-title {
	font-size: 14px;
	font-weight: 700;
	word-break: break-word;
}
.pp-body {
	font-size: 13px;
	line-height: 1.35;
	word-break: break-word;
	white-space: pre-line;
}
.pp-empty {
	color: #8a96a3;
	font-weight: 400;
	font-style: italic;
}
.pp-image {
	margin-top: 8px;
	border-radius: 10px;
	overflow: hidden;
}
.pp-image img {
	display: block;
	width: 100%;
	max-height: 160px;
	object-fit: cover;
}
.pp-image-ko {
	margin-top: 8px;
	font-size: 11px;
	color: #b3261e;
}
.pp-link {
	margin-top: 8px;
	text-align: center;
	font-size: 11px;
	opacity: 0.85;
}
</style>
